import React from 'react';
import DashboardLayout from "../layout";
import AddressForm from "./AddressForm";
import { useNavigate } from "react-router-dom";

const NewQuoteRequestForm = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/bookshipment');
  };

  return (
    <DashboardLayout>
      <div className="w-full">
        <AddressForm onBack={handleBack} />
      </div>
    </DashboardLayout>
  );
};

export default NewQuoteRequestForm;